<div
  class="mobile-drawer"
  [class.mobile-drawer--open]="open()"
  [attr.inert]="open() ? null : ''">
  <div
    class="mobile-drawer__backdrop"
    data-testid="mobile-drawer-backdrop"
    aria-hidden="true"
    (click)="close()"></div>

  <div
    #panel
    id="mobile-navigation-drawer"
    class="mobile-drawer__panel"
    data-testid="mobile-drawer"
    role="dialog"
    aria-modal="true"
    aria-label="Menu de navegação"
    (keydown)="trapFocus($event)">
    <header class="mobile-drawer__header">
      <h2 class="mobile-drawer__title">Menu</h2>
      <button
        #closeButton
        type="button"
        class="mobile-drawer__close"
        data-testid="mobile-drawer-close"
        aria-label="Fechar menu"
        (click)="close()">
        <lucide-icon
          name="x"
          [size]="20"
          [strokeWidth]="1.75"
          aria-hidden="true" />
      </button>
    </header>

    <nav
      class="mobile-drawer__scroll"
      aria-label="Navegação completa"
      data-testid="mobile-drawer-scroll">
      @if (operationDomains().length > 0) {
        <section class="mobile-drawer__group">
          <h3 class="mobile-drawer__group-label">Operação</h3>
          <ul class="mobile-drawer__list">
            @for (domain of operationDomains(); track domain.id) {
              <li><ng-container *ngTemplateOutlet="domainTpl; context: { $implicit: domain }" /></li>
            }
          </ul>
        </section>
      }

      @if (adminDomains().length > 0) {
        <section class="mobile-drawer__group mobile-drawer__group--admin">
          <h3 class="mobile-drawer__group-label">Administração</h3>
          <ul class="mobile-drawer__list">
            @for (domain of adminDomains(); track domain.id) {
              <li><ng-container *ngTemplateOutlet="domainTpl; context: { $implicit: domain }" /></li>
            }
          </ul>
        </section>
      }
    </nav>
  </div>
</div>

<ng-template
  #domainTpl
  let-domain>
  @if (domain.directRoute) {
    <a
      class="mobile-drawer__row"
      [class.mobile-drawer__row--active]="isDomainActive(domain)"
      [attr.data-testid]="'mobile-drawer-domain-' + domain.id"
      [attr.aria-current]="isDomainActive(domain) ? 'page' : null"
      [routerLink]="domain.directRoute">
      <lucide-icon
        [name]="domain.icon"
        [size]="18"
        [strokeWidth]="1.75"
        aria-hidden="true" />
      <span class="mobile-drawer__row-label">{{ domain.label }}</span>
    </a>
  } @else {
    <button
      type="button"
      class="mobile-drawer__row"
      [class.mobile-drawer__row--active]="isDomainActive(domain)"
      [attr.data-testid]="'mobile-drawer-domain-' + domain.id"
      [attr.aria-expanded]="isExpanded(domain)"
      [attr.aria-controls]="'mobile-drawer-group-' + domain.id"
      (click)="toggle(domain)">
      <lucide-icon
        [name]="domain.icon"
        [size]="18"
        [strokeWidth]="1.75"
        aria-hidden="true" />
      <span class="mobile-drawer__row-label">{{ domain.label }}</span>
      <lucide-icon
        class="mobile-drawer__chevron"
        [class.mobile-drawer__chevron--open]="isExpanded(domain)"
        name="chevron-down"
        [size]="16"
        [strokeWidth]="1.75"
        aria-hidden="true" />
    </button>

    @if (isExpanded(domain)) {
      <div
        class="mobile-drawer__submenu"
        [id]="'mobile-drawer-group-' + domain.id">
        @for (section of domain.sections; track section.id) {
          @if (section.label) {
            <p class="mobile-drawer__section-label">{{ section.label }}</p>
          }
          <ul class="mobile-drawer__list">
            @for (item of section.items; track testId(item)) {
              <li>
                <a
                  class="mobile-drawer__link"
                  [class.mobile-drawer__link--active]="isDestinationActive(item)"
                  [attr.data-testid]="'mobile-drawer-link-' + testId(item)"
                  [attr.aria-current]="isDestinationActive(item) ? 'page' : null"
                  [routerLink]="item.route"
                  [queryParams]="item.queryParams">
                  <lucide-icon
                    [name]="item.icon"
                    [size]="16"
                    [strokeWidth]="1.75"
                    aria-hidden="true" />
                  <span>{{ item.label }}</span>
                </a>
              </li>
            }
          </ul>
        }
      </div>
    }
  }
</ng-template>
